import React, {useEffect, useState} from "react";
import {useLocation, Link} from "react-router-dom";


const Resualt = () => {

    const location = useLocation();
    const [iframeSrc, setIframSrc] = useState("")
    const [resualt, setResualt] = useState(false);

    useEffect(() => {
        SetDate()
    }, [])
    const SetDate = () => {
        if (location.state) {
            setIframSrc(location.state)
            setResualt(true)
        } else setResualt(false)
    }

    return (


        <div className="pt-3">
            <div className={resualt ? "text-center mb-5 d-block" : "d-none"}>
                <Link to="/" className="p-lg-btn ">
                    بازگشت به صفحه ی اسکن
                </Link>
            </div>
            {
                resualt
                    ?
                    <div className="iframe-box">
                        <iframe title="اطلاعات بلیت" src={iframeSrc} className="iframe"/>
                    </div>
                    :
                    <div className="no-resualt-box">
                        <p>
                            هیچ پاسخی از مرکز دریافت نشد. ابتدا باید کد خودرا از طریق لینک زیر، اسکن کنید.
                        </p>
                        <div className="text-center mt-5 d-block">
                            <Link to="/" className="p-lg-btn ">
                                بازگشت به صفحه ی اسکن
                            </Link>
                        </div>
                    </div>

            }


        </div>

    )

}
export default Resualt